<template>
    <div class="role publicViewClass">
         <div class="show_container">
             <div class="staff_manage_head flex  align-cen">
                  <div class="search_box">
                     <el-input placeholder="请输入角色名称" v-model="search" clearable> </el-input>
                </div>
                <div class="public-btn-small flex align-cen" style="padding-left:20px">
                    <div class="public-btn-small-primary"  @click="gethisList">搜索</div>
                    <div class="public-btn-small-text" @click="reset">重置筛选条件</div>
                </div>
             </div>
              <div class="staff_manage_center">
                <div class="public-list-container">
                    <div class="public-list-container-table">
                        <div class="public-list-container-table-header flex align-cen">
                            <div class="rolename">角色名称</div>
                            <div class="roleDe">角色描述</div>
                        </div>
                        <div v-if="itemList.length">
                        <div class="public-list-container-table-row flex align-cen"
                        v-for="(item,index) in itemList"
                        >
                              <div class="rolename">
                                {{item.roleName}}
                              </div>
                            <div class="roleDe">
                                {{item.description}}
                            </div>
                        </div>
                        </div>
                        <div v-else class="no-empry">
                            暂无数据
                        </div>
                    </div>
                </div>
                 <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
              </div>
         </div>
    </div>
</template>
<script>
import { getRoleName} from "@/api/enterprise/index"; // 角色列表
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    nam:'role',
     components:{
      paginaTion
    },
    data() {
        return {
          search:'',
          currentPage: 1, //初始页
          PageSize: 10, //每页的数据
          totalCount:0,
          itemList:[],  
        }
    },
    created () {
        this.gethisList()
    },
    methods: {
                // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList()
      },
        reset(){
             this.search = ''
            this.currentPage1 = 1
            this.gethisList()
        },
        gethisList(){
             let params = {
                roleName:this.search,
                size:this.PageSize,
                current:this.currentPage,
            }
            getRoleName(params,'enterprise')
            .then(res =>{
               this.itemList = res.data.records
            this.totalCount = res.data.total
            })
            .catch(err =>{})
        },
    },
}
</script>
<style lang="scss" scoped>
.public-list-container{
    position: relative;
    .public-list-container-table{
        .public-list-container-table-header{
            .rolename{
                width: 30%;
                text-align: center;
            }
            .roleDe{
                width: 70%;
                text-align: center;
            }
        }
        .public-list-container-table-row {
                 .rolename{
                width: 30%;
                text-align: center;
            }
            .roleDe{
                width: 70%;
                text-align: center;
            }
        }
    }
}
::v-deep{
    .jiange{
        padding-bottom: 20px;
        margin-right: 10px;
    }
}
</style> 